import { SetupData } from './types';

export const SET_BLOCKS = 'SET_BLOCKS';
export const UPDATE_BLOCK = 'UPDATE_BLOCK';
export const SET_BLOCKDATA = 'SET_BLOCKDATA'; // replace part of block, not the whole thing like SET_BLOCKS
export const SET_SETUPDATA = 'SET_SETUPDATA';
export const UPDATE_SETUPDATA = 'UPDATE_SETUPDATA';
export const SET_USERDATA = 'SET_USERDATA';
export const DELETE_BLOCKS = 'DELETE_BLOCKS';

export const SET_BLOCK_PROGRESS = 'SET_BLOCK_PROGRESS';

export const UPDATE_BLOCK_PROGRESSSETTINGS = 'UPDATE_BLOCK_PROGRESSSETTINGS';
export const UPDATE_BLOCK_SHARINGSETTINGS = 'UPDATE_BLOCK_SHARINGSETTINGS';
export const UPDATE_BLOCK_GROUPWORKSETTINGS = 'UPDATE_BLOCK_GROUPWORKSETTINGS';

export const UPDATE_PORTFOLIO_SETTINGS = 'UPDATE_PORTFOLIO_SETTINGS';

export const MOVE_BLOCK_START = 'MOVE_BLOCK_START';

export const UPDATE_BLOCK_AUTOSAVE_START = 'UPDATE_BLOCK_AUTOSAVE_START';
export const UPDATE_BLOCK_AUTOSAVE_FINISHED = 'UPDATE_BLOCK_AUTOSAVE_FINISHED';
export const UPDATE_BLOCK_AUTOSAVE_FAILED = 'UPDATE_BLOCK_AUTOSAVE_FAILED';

export const BLOCK_DATA_FETCH_SUCCESS = 'BLOCK_DATA_FETCH_SUCCESS';

export const BLOCK_FILES_DATA_FETCH_SUCCESS = 'BLOCK_FILES_DATA_FETCH_SUCCESS';
export const LOOKUP_BLOCK_FAILED = 'LOOKUP_BLOCK_FAILED';

export interface SetupDataUpdateAction {
  type: 'UPDATE_SETUPDATA';
  blockID: string;
  setupData: SetupData;
}

export interface SetBlockProgressAction {
  type: 'SET_BLOCK_PROGRESS';
  blockID: string;
  value: string;
}

export interface BlockAutoSaveStartAction {
  type: 'UPDATE_BLOCK_AUTOSAVE_START';
  blockID: string;
  text: string;
}

export interface BlockAutoSaveFinishedAction {
  type: 'UPDATE_BLOCK_AUTOSAVE_FINISHED';
  blockID: string;
}

export interface BlockAutoSaveFailedAction {
  type: 'UPDATE_BLOCK_AUTOSAVE_FAILED';
  blockID: string;
  error: string;
}

export type BlockAction =
  | SetupDataUpdateAction
  | SetBlockProgressAction
  | BlockAutoSaveStartAction
  | BlockAutoSaveFinishedAction
  | BlockAutoSaveFailedAction;
